<template>
  <div class="footer">
    <div class="company-info flexstart" v-if="showPlatform">
      <div class="flexcolumn" style="margin-right: 5.3125rem">
        <div class="logo-box">
          <img class="logo-img" :src="gsInfo.web_foot_logo" alt="" />
        </div>
        <p class="mb16">地址/Add: {{ gsInfo.address }}</p>
        <p class="mb16">电话/Tel: {{ gsInfo.tel_phone }}</p>
        <p>邮箱/Email: {{ gsInfo.email }}</p>
      </div>
      <div class="footer-nav">
        <div
          class="info-item-box"
          v-for="item in footerNavList"
          :key="item.nav_id"
        >
          <p class="nav-name">{{ item.nav_name }}</p>
          <div class="info-item-list" v-if="item.children.length > 0">
            <p
              class="link-title"
              v-for="item2 in item.children"
              :key="item2.nav_id"
              @click="toDetails(item2)"
            >
              {{ item2.nav_name }}
            </p>
          </div>
        </div>
      </div>
      <div class="gsxxitem flexstart">
        <div class="codebox">
          <div class="wximg">
            <img src="@/assets/images/lxwm/weibo.jpg" alt="" />
          </div>
          <p class="title">{{ $t("lxwmView.wb") }}</p>
        </div>
        <div class="codebox">
          <div class="wximg">
            <img src="@/assets/images/lxwm/wx.png" alt="" />
          </div>
          <p class="title">{{ $t("lxwmView.wx") }}</p>
        </div>
      </div>
    </div>
    <div
      class="copy-info flexcolumn flexcenter"
      :style="{ backgroundColor: bgcolor.background, color: bgcolor.ftcolor }"
    >
      <div class="filings-text">
        <p class="mb10">
          {{ $t("layoutView.bq1")
          }}<a href="https://beian.miit.gov.cn" target="_blank">{{
            $t("layoutView.bq2")
          }}</a>
        </p>
        <p>{{ $t("layoutView.bq3") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showPlatform: {
      type: Boolean,
      default: true,
    },
    // 背景颜色对象
    bgcolor: {
      type: Object,
      default: () => ({
        background: "#333",
        ftcolor: "#fff",
      }),
    },
    gsInfo: {
      type: Object,
    },
    footerNavList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      companyInfo: {},
    };
  },
  computed: {},
  created() {},
  mounted() {
    // getComInfo()
  },
  watch: {},
  methods: {
    // 跳转详情页
    toDetails(nav) {
      //子菜单参数缓存
      let query = {};
      if (nav.type_id) {
        query = this.parseParamsString(nav.type_id);
      }
      this.currentSubnavIndex = nav.nav_id;
      localStorage.setItem("childNavIndex", nav.nav_id);
      //新增判断：若切换的路由与当前路由一致，则刷新页面（出口页面通用一个页面路由，需要传递参数区分）
      if (
        nav.nav_url === this.$route.path &&
        this.$route.meta.title != nav.nav_name
      ) {
        // 传递新的参数并刷新页面
        this.reloadWithParams(query);
        return;
      }
      // nav.link_params参数形式为 key=value&key=value，处理成key:value对象,
      this.$router.push({
        path: nav.nav_url,
        query: query,
      });
    },
    reloadWithParams(val) {
      // 创建新的路由对象
      const newRoute = {
        path: this.$route.path,
        query: val,
      };
      // 替换当前路由
      this.$router.replace(newRoute);
      // window.location.reload();
    }, // 解析参数字符串的方法
    parseParamsString(paramsString) {
      if (!paramsString) return {};

      const params = {};
      const paramsArray = paramsString.split(",");

      paramsArray.forEach((param) => {
        const [key, value] = param.split("=");
        params[key] = decodeURIComponent(value);
      });

      return params;
    },
    // 跳转网站
    toSite(site) {
      window.open(site, "_blank");
    },
    //跳转政策法规
    toCrossInfo(name) {
      localStorage.setItem("currentNavIndex", 8);
      this.$router.push({
        path: "/crossInfo",
        query: {
          name: name,
        },
      });
    },
  },
  components: {},
};
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  background: #1390d8;
  .company-info {
    width: 100rem;
    margin: 0 auto;
    padding: 2.375rem 0;
    // background: #1390d8;
    color: #fff;
    font-size: 1.25rem; //cs20px
    .footer-nav {
      display: flex;
      .info-item-box {
      width: 12.5rem;
        margin-right: 5rem;
        &:last-child {
          margin-right: 0;
        }
        .nav-name {
          font-size: 1.25rem;
          font-weight: bold;
          line-height: 1.5rem;
          margin-bottom: 1.25rem;
        }
      }
      .link-title {
        font-size: 1.25rem;
        line-height: 2rem;
        cursor: pointer;
      }
    }
    .logo-box {
      width: 25.9375rem;
      height: 4.3125rem;
      margin-bottom: 1.25rem;
      .logo-img {
        width: 23.75rem;
        // height: 4.375rem;
      }
    }
    .qrcode {
      width: 11.0625rem;
      height: 11.0625rem;
    }
    .gsxxitem {
      margin-left: 5.3125rem;
      .codebox {
        width: 8rem;
        height: 10.375rem;
        margin-right: 3.125rem;
        .wximg {
          width: 8rem;
          height: 8rem;
          margin-bottom: 0.625rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          font-size: 1.25rem;
          text-align: center;
        }
      }
    }
  }
}
.copy-info {
  width: 100%;
  // background: #333;
  font-size: 1.25rem; //cs20px
  // color: #afafaf !important;
  padding-top: 1.0625rem;
  padding-bottom: 1.6875rem;
  .company-box {
    // color: #fff;
    .company-name {
      position: relative;
      padding: 0 1.125rem;
      cursor: pointer;
      &:not(:last-child):after {
        content: "";
        width: 1px;
        height: 0.4375rem;
        background: #fff;
        position: absolute;
        right: -0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .hold-company-name {
    cursor: pointer;
    position: relative;
    padding: 0 1.125rem;
    &::after {
      content: "";
      width: 1px;
      height: 0.4375rem;
      background: #afafaf;
      position: absolute;
      right: -0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .filings-text {
    opacity: 0.5;
    text-align: center;
  }
}
</style>
